<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      A crime scene diagram is a very useful tool for a forensic scientist to have. Crime scene
      diagrams visually document several important pieces of information, including:
    </p>
    <ul class="default-list">
      <li>Layout</li>
      <li>Location of the victim</li>
      <li>Evidence</li>
      <li>Notes</li>
    </ul>
    <p class="mb-5">
      In the old days, crime scene diagrams would be painstakingly drawn out by hand. These days, we
      have powerful software available to help.
    </p>
    <p class="mb-5">
      SmartDraw is one such software tool. Luckily, it is available on a 7-day trial for free. To
      set up an account, go here and follow the onscreen instructions:
    </p>
    <centered-image-wrapper
      class="cursor-pointer"
      classes="2/3"
      :image="image1"
      label="Open the SmartDraw crime scene investigation software page"
      @clicked="
        showIframePopup(
          'https://www.smartdraw.com/crime-scene/crime-scene-investigation-software.htm',
        )
      "
    />

    <p class="mb-5">
      Once you have an account set up, you’ll need to learn how to use the software.
    </p>
    <p class="mb-5">Here are two excellent resources to help you make the most of SmartDraw.</p>
    <p class="mb-5 text-italic">
      On the left is a video tutorial and on the right is a written tutorial – they are both really
      helpful:
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-2/3 lg:w-1/2 w-full my-5 flex justify-center">
        <button
          type="button"
          class="no-style img-click-button"
          aria-label="Play video: SmartDraw crime scene diagram tutorial"
          @click="showVideoPopup(videos[1].url)"
        >
          <img
            src="@/assets/images/experiences/forensic_science/smartdraw_video_tutorial_splash.jpg"
            class="mx-auto mb-5 img-responsive cursor-pointer"
            alt=""
          />
        </button>
      </div>
      <div class="vx-col xl:w-1/3 lg:w-1/2 w-full my-5">
        <button
          type="button"
          class="no-style img-click-button"
          aria-label="Open the SmartDraw crime scene diagram written tutorial"
          @click="showIframePopup('https://www.smartdraw.com/crime-scene/')"
        >
          <img
            src="@/assets/images/experiences/forensic_science/smartdraw_text_tutorial_button.jpg"
            class="mx-auto mb-5 img-responsive cursor-pointer"
            alt=""
          />
        </button>
      </div>
    </div>

    <p class="mb-5">
      Once you have worked your way through these tutorials, you’ll need a crime scene to base your
      diagram on.
    </p>
    <p class="mb-5">
      Watch the video below for a presentation of a mock crime scene. It’s full of detail.
    </p>
    <responsive-youtube-wrapper :video="videos[2].url" :image="videos[2].image" />

    <p class="mb-5">
      You’ll need to watch it carefully and extract as much detail about the scene as possible. So,
      be sure to take plenty of notes and pause the video where necessary.
    </p>
    <p class="mb-5">
      Once you have all the information you need, use SmartDraw to create as detailed a crime scene
      diagram as possible.
    </p>
    <p class="mb-5">
      When you have completed your crime scene diagram, take a screenshot of your efforts and upload
      it here.
    </p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Image'"
      index="1"
      filetype="media"
    />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/forensic_science/shoeprint_splash.jpg'),
          url: 'https://www.youtube.com/embed/V4cFAQ-VUtk',
        },
        2: {
          image: require('@/assets/images/experiences/forensic_science/crime_scene_splash.jpg'),
          url: 'https://www.youtube.com/embed/3eicwd73YoY',
        },
      },
      image1: require('@/assets/images/experiences/forensic_science/smartdraw_button.jpg'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
